import { render, staticRenderFns } from "./SynthesisTableView.vue?vue&type=template&id=2cdfd7bb&"
import script from "./SynthesisTableView.vue?vue&type=script&lang=ts&"
export * from "./SynthesisTableView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports